<template>
  <div class="columns">
    <div class="column">
      <div class="title is-5">{{ $t("final octaves") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match0"
            v-bind:class="{
              'is-info': match_0_winner && match_0_winner == players[0],
            }"
            @click="win(0, players[0], $event)"
          >
            {{ players[0] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match0"
            v-bind:class="{
              'is-info': match_0_winner && match_0_winner == players[1],
            }"
            @click="win(0, players[1], $event)"
          >
            {{ players[1] }}
          </div>
        </div>
      </div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match2"
            v-bind:class="{
              'is-info': match_2_winner && match_2_winner == players[4],
            }"
            @click="win(2, players[4], $event)"
          >
            {{ players[4] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match2"
            v-bind:class="{
              'is-info': match_2_winner && match_2_winner == players[5],
            }"
            @click="win(2, players[5], $event)"
          >
            {{ players[5] }}
          </div>
        </div>
      </div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match4"
            v-bind:class="{
              'is-info': match_4_winner && match_4_winner == players[8],
            }"
            @click="win(4, players[8], $event)"
          >
            {{ players[8] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match4"
            v-bind:class="{
              'is-info': match_4_winner && match_4_winner == players[9],
            }"
            @click="win(4, players[9], $event)"
          >
            {{ players[9] }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match6"
            v-bind:class="{
              'is-info': match_6_winner && match_6_winner == players[12],
            }"
            @click="win(6, players[12], $event)"
          >
            {{ players[12] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match6"
            v-bind:class="{
              'is-info': match_6_winner && match_6_winner == players[13],
            }"
            @click="win(6, players[13], $event)"
          >
            {{ players[13] }}
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final quarters") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match8"
            v-bind:class="{
              'is-info':
                match_8_winner &&
                match_0_winner &&
                match_8_winner == match_0_winner,
            }"
            @click="win(8, match_0_winner, $event)"
          >
            {{ match_0_winner }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match8"
            v-bind:class="{
              'is-info':
                match_8_winner &&
                match_2_winner &&
                match_8_winner == match_2_winner,
            }"
            @click="win(8, match_2_winner, $event)"
          >
            {{ match_2_winner }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match10"
            v-bind:class="{
              'is-info':
                match_10_winner &&
                match_4_winner &&
                match_10_winner == match_4_winner,
            }"
            @click="win(10, match_4_winner, $event)"
          >
            {{ match_4_winner }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match10"
            v-bind:class="{
              'is-info':
                match_10_winner &&
                match_6_winner &&
                match_10_winner == match_6_winner,
            }"
            @click="win(10, match_6_winner, $event)"
          >
            {{ match_6_winner }}
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-3">
        <div
          class="button is-medium match12"
          v-bind:class="{
            'is-info':
              match_12_winner &&
              match_8_winner &&
              match_12_winner == match_8_winner,
          }"
          @click="win(12, match_8_winner, $event)"
        >
          {{ match_8_winner }}
        </div>
      </div>
      <div>
        <div
          class="button is-medium match12"
          v-bind:class="{
            'is-info':
              match_12_winner &&
              match_10_winner &&
              match_12_winner == match_10_winner,
          }"
          @click="win(12, match_10_winner, $event)"
        >
          {{ match_10_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div
        class="button is-medium match14"
        v-bind:class="{
          'is-info':
            match_14_winner &&
            match_12_winner &&
            match_14_winner == match_12_winner,
        }"
        @click="win(14, match_12_winner, $event)"
      >
        {{ match_12_winner }}
      </div>
    </div>
    <div class="column">
      <div class="title is-4 has-text-primary">{{ $t("champion") }}</div>
      <div
        class="button is-medium"
        v-bind:class="{
          'is-warning': match_14_winner,
        }"
      >
        <span class="icon">
          <i class="fa fa-trophy"></i>
        </span>
        <span>{{ match_14_winner }}</span>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div
        class="button is-medium match14"
        v-bind:class="{
          'is-info':
            match_14_winner &&
            match_13_winner &&
            match_14_winner == match_13_winner,
        }"
        @click="win(14, match_13_winner, $event)"
      >
        {{ match_13_winner }}
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-3">
        <div
          class="button is-medium match13"
          v-bind:class="{
            'is-info':
              match_13_winner &&
              match_9_winner &&
              match_13_winner == match_9_winner,
          }"
          @click="win(13, match_9_winner, $event)"
        >
          {{ match_9_winner }}
        </div>
      </div>
      <div class="">
        <div
          class="button is-medium match13"
          v-bind:class="{
            'is-info':
              match_13_winner &&
              match_11_winner &&
              match_13_winner == match_11_winner,
          }"
          @click="win(13, match_11_winner, $event)"
        >
          {{ match_11_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final quarters") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match9"
            v-bind:class="{
              'is-info':
                match_9_winner &&
                match_1_winner &&
                match_9_winner == match_1_winner,
            }"
            @click="win(9, match_1_winner, $event)"
          >
            {{ match_1_winner }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match9"
            v-bind:class="{
              'is-info':
                match_9_winner &&
                match_3_winner &&
                match_9_winner == match_3_winner,
            }"
            @click="win(9, match_3_winner, $event)"
          >
            {{ match_3_winner }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match11"
            v-bind:class="{
              'is-info':
                match_11_winner &&
                match_5_winner &&
                match_11_winner == match_5_winner,
            }"
            @click="win(11, match_5_winner, $event)"
          >
            {{ match_5_winner }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match11"
            v-bind:class="{
              'is-info':
                match_11_winner &&
                match_7_winner &&
                match_11_winner == match_7_winner,
            }"
            @click="win(11, match_7_winner, $event)"
          >
            {{ match_7_winner }}
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final octaves") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match1"
            v-bind:class="{
              'is-info': match_1_winner && match_1_winner == players[2],
            }"
            @click="win(1, players[2], $event)"
          >
            {{ players[2] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match1"
            v-bind:class="{
              'is-info': match_1_winner && match_1_winner == players[3],
            }"
            @click="win(1, players[3], $event)"
          >
            {{ players[3] }}
          </div>
        </div>
      </div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match3"
            v-bind:class="{
              'is-info': match_3_winner && match_3_winner == players[6],
            }"
            @click="win(3, players[6], $event)"
          >
            {{ players[6] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match3"
            v-bind:class="{
              'is-info': match_3_winner && match_3_winner == players[7],
            }"
            @click="win(3, players[7], $event)"
          >
            {{ players[7] }}
          </div>
        </div>
      </div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match5"
            v-bind:class="{
              'is-info': match_5_winner && match_5_winner == players[10],
            }"
            @click="win(5, players[10], $event)"
          >
            {{ players[10] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match5"
            v-bind:class="{
              'is-info': match_5_winner && match_5_winner == players[11],
            }"
            @click="win(5, players[11], $event)"
          >
            {{ players[11] }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match7"
            v-bind:class="{
              'is-info': match_7_winner && match_7_winner == players[14],
            }"
            @click="win(7, players[14], $event)"
          >
            {{ players[14] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match7"
            v-bind:class="{
              'is-info': match_7_winner && match_7_winner == players[15],
            }"
            @click="win(7, players[15], $event)"
          >
            {{ players[15] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SixteenPeople",
  props: {
    players: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      match_0_winner: "",
      match_1_winner: "",
      match_2_winner: "",
      match_3_winner: "",
      match_4_winner: "",
      match_5_winner: "",
      match_6_winner: "",
      match_7_winner: "",
      match_8_winner: "",
      match_9_winner: "",
      match_10_winner: "",
      match_11_winner: "",
      match_12_winner: "",
      match_13_winner: "",
      match_14_winner: "",
    };
  },
  methods: {
    win(round, player, event) {
      if (round === 0) {
        this.match_0_winner = player;
        window.jQuery(".match0").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 1) {
        this.match_1_winner = player;
        window.jQuery(".match1").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 2) {
        this.match_2_winner = player;
        window.jQuery(".match2").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 3) {
        this.match_3_winner = player;
        window.jQuery(".match3").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 4) {
        this.match_4_winner = player;
        window.jQuery(".match4").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 5) {
        this.match_5_winner = player;
        window.jQuery(".match5").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 6) {
        this.match_6_winner = player;
        window.jQuery(".match6").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 7) {
        this.match_7_winner = player;
        window.jQuery(".match7").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 8) {
        this.match_8_winner = player;
        window.jQuery(".match8").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 9) {
        this.match_9_winner = player;
        window.jQuery(".match9").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 10) {
        this.match_10_winner = player;
        window.jQuery(".match10").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 11) {
        this.match_11_winner = player;
        window.jQuery(".match11").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 12) {
        this.match_12_winner = player;
        window.jQuery(".match12").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 13) {
        this.match_13_winner = player;
        window.jQuery(".match13").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 14) {
        this.match_14_winner = player;
        window.jQuery(".match14").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      }
    },
    get_results() {
      return {
        matches: {
          0: {
            winner: this.match_0_winner,
            players: [this.players[0], this.players[1]],
          },
          1: {
            winner: this.match_1_winner,
            players: [this.players[2], this.players[3]],
          },
          2: {
            winner: this.match_2_winner,
            players: [this.players[4], this.players[5]],
          },
          3: {
            winner: this.match_3_winner,
            players: [this.players[6], this.players[7]],
          },
          4: {
            winner: this.match_4_winner,
            players: [this.players[8], this.players[9]],
          },
          5: {
            winner: this.match_5_winner,
            players: [this.players[10], this.players[11]],
          },
          6: {
            winner: this.match_6_winner,
            players: [this.players[12], this.players[13]],
          },
          7: {
            winner: this.match_7_winner,
            players: [this.players[14], this.players[15]],
          },
          8: {
            winner: this.match_8_winner,
            players: [this.match_0_winner, this.match_2_winner],
          },
          9: {
            winner: this.match_9_winner,
            players: [this.match_1_winner, this.match_3_winner],
          },
          10: {
            winner: this.match_10_winner,
            players: [this.match_4_winner, this.match_6_winner],
          },
          11: {
            winner: this.match_11_winner,
            players: [this.match_5_winner, this.match_7_winner],
          },
          12: {
            winner: this.match_12_winner,
            players: [this.match_8_winner, this.match_10_winner],
          },
          13: {
            winner: this.match_13_winner,
            players: [this.match_9_winner, this.match_11_winner],
          },
          14: {
            winner: this.match_14_winner,
            players: [this.match_12_winner, this.match_13_winner],
          },
        },
      };
    },
    set_results(results) {
      let v = this;
      if (results && results.matches) {
        if (results.matches[0]) {
          v.match_0_winner = results.matches[0].winner;
        }
        if (results.matches[1]) v.match_1_winner = results.matches[1].winner;
        if (results.matches[2]) v.match_2_winner = results.matches[2].winner;
        if (results.matches[3]) v.match_3_winner = results.matches[3].winner;
        if (results.matches[4]) v.match_4_winner = results.matches[4].winner;
        if (results.matches[5]) v.match_5_winner = results.matches[5].winner;
        if (results.matches[6]) v.match_6_winner = results.matches[6].winner;
        if (results.matches[7]) v.match_7_winner = results.matches[7].winner;
        if (results.matches[8]) v.match_8_winner = results.matches[8].winner;
        if (results.matches[9]) v.match_9_winner = results.matches[9].winner;
        if (results.matches[10]) v.match_10_winner = results.matches[10].winner;
        if (results.matches[11]) v.match_11_winner = results.matches[11].winner;
        if (results.matches[12]) v.match_12_winner = results.matches[12].winner;
        if (results.matches[13]) v.match_13_winner = results.matches[13].winner;
        if (results.matches[14]) v.match_14_winner = results.matches[14].winner;
      }
    },
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
